import React from "react";
import { Box } from "@mui/material";
import Payouts from "../../../../components/Connect/Payouts";

function EarningHistory({ accountId }) {
  return (
    <Box sx={{ width: "100%" }}>
      <Payouts accountId={accountId} />
    </Box>
  );
}

export default EarningHistory;
